import {UseFormGetValues, UseFormSetValue} from "react-hook-form";
import {AchFormValues, CardFormValues} from "../types";
import {formatInput, parseExpirationDate} from "../utils";
import {buildDevAchPreset, buildDevCardPreset} from "./devPaymentPresets";

const SET_VALUE_OPTIONS = {shouldValidate: true, shouldDirty: true};

interface DevCardAutofillParams {
  setValue: UseFormSetValue<CardFormValues>;
  getValues: UseFormGetValues<CardFormValues>;
  setCardInput: (value: string) => void;
}

interface DevAchAutofillParams {
  setValue: UseFormSetValue<AchFormValues>;
  getValues: UseFormGetValues<AchFormValues>;
}

export const fillDevCardForm = ({setValue, getValues, setCardInput}: DevCardAutofillParams) => {
  const preset = buildDevCardPreset();
  const expirationDate = parseExpirationDate(preset.expirationDate);
  setCardInput(formatInput(preset.cardNumber));
  setValue("cardNumber", preset.cardNumber, SET_VALUE_OPTIONS);
  setValue("name", getValues("name") || preset.name, SET_VALUE_OPTIONS);
  setValue("expirationMonth", expirationDate?.format("MM") ?? "", SET_VALUE_OPTIONS);
  setValue("expirationYear", expirationDate?.format("YYYY") ?? "", SET_VALUE_OPTIONS);
  setValue("cvv", preset.cvv, SET_VALUE_OPTIONS);
  setValue("zip", preset.zip, SET_VALUE_OPTIONS);
  setValue("email", getValues("email") || preset.email, SET_VALUE_OPTIONS);
  setValue("confirmTerms", true, SET_VALUE_OPTIONS);
};

export const fillDevAchForm = ({setValue, getValues}: DevAchAutofillParams) => {
  const preset = buildDevAchPreset();
  setValue("accountNumber", preset.accountNumber, SET_VALUE_OPTIONS);
  setValue("routingNumber", preset.routingNumber, SET_VALUE_OPTIONS);
  setValue("name", getValues("name") || preset.name, SET_VALUE_OPTIONS);
  setValue("accountType", preset.accountType, SET_VALUE_OPTIONS);
  setValue("email", getValues("email") || preset.email, SET_VALUE_OPTIONS);
  setValue("confirmTerms", true, SET_VALUE_OPTIONS);
};
